import React from 'react';
import IconInstagram from './IconInstagram';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconIstagramUpload: React.FC<IconProps> = ({ width = 22, height = 22, color = 'white' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.97565 7.05755L10.084 4.94922V13.7492C10.084 14.2992 10.4507 14.6659 11.0007 14.6659C11.5507 14.6659 11.9173 14.2992 11.9173 13.7492V4.94922L14.0257 7.05755C14.3923 7.42422 14.9423 7.42422 15.309 7.05755C15.6757 6.69089 15.6757 6.14089 15.309 5.77422L11.6423 2.10755C11.5507 2.01589 11.459 1.92422 11.3673 1.92422C11.184 1.83255 10.909 1.83255 10.634 1.92422C10.5423 1.92422 10.4507 2.01589 10.359 2.10755L6.69232 5.77422C6.32565 6.14089 6.32565 6.69089 6.69232 7.05755C7.05898 7.42422 7.60898 7.42422 7.97565 7.05755ZM19.2507 12.8326C18.7007 12.8326 18.334 13.1992 18.334 13.7492V17.4159C18.334 17.9659 17.9673 18.3326 17.4173 18.3326H4.58398C4.03398 18.3326 3.66732 17.9659 3.66732 17.4159V13.7492C3.66732 13.1992 3.30065 12.8326 2.75065 12.8326C2.20065 12.8326 1.83398 13.1992 1.83398 13.7492V17.4159C1.83398 18.9742 3.02565 20.1659 4.58398 20.1659H17.4173C18.9757 20.1659 20.1673 18.9742 20.1673 17.4159V13.7492C20.1673 13.1992 19.8007 12.8326 19.2507 12.8326Z"
                fill={color}
            />
        </svg>
    );
};

export default IconIstagramUpload;
